import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { interval, Subscription, take } from 'rxjs';

import { AuthService } from '@app/features/auth/services/auth.service';

@Component({
  selector: 'app-email-varification',
  imports: [CommonModule, RouterModule , NgOptimizedImage],
  templateUrl: './email-varification.html',
  styleUrl: './email-varification.scss'
})
export class EmailVarification implements OnInit, OnDestroy {
  isResetBtnDisabled = false;
  buttonText = '';
  showTimer = false
  showToaster = false;
  message = ''
  private countdownSubscription: Subscription | null = null;
  constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef , private authService : AuthService) { }
  ngOnInit(): void {
    const status = this.route.snapshot.queryParamMap.get('status');
    if (status === 'already_verified' || status === 'success') {
      this.message = status === 'already_verified' ? 'Your email is already verified' : 'Your email has been verified successfully!'
      this.showToaster = true
      // setTimeout(()=> {
      //   this.router.navigate(['/login']);
      // },1000)
    }

  }
  startCountdown(duration: number) {
    this.isResetBtnDisabled = true;

    // Clear previous countdown if exists
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }

    // Display initial value immediately
    this.updateButtonText(duration);

    // Start countdown
    this.countdownSubscription = interval(1000)
      .pipe(take(duration))
      .subscribe({
        next: (elapsed) => {
          const timeLeft = duration - elapsed - 1;
          this.updateButtonText(timeLeft);
          this.cdr.detectChanges()
        },
        complete: () => {
          this.isResetBtnDisabled = false;
          this.cdr.detectChanges()
        },
      });
  }

  private updateButtonText(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const mm = minutes < 10 ? '0' + minutes : minutes;
    const ss = secs < 10 ? '0' + secs : secs;
    this.buttonText = `${mm}:${ss}`;
  }

  resendEmail() {
    const email = this.route.snapshot.queryParamMap.get('email')
    const data = {
        email : email
    }
    this.showTimer = true
    this.cdr.detectChanges()
    this.startCountdown(120);
    this.authService.resendEmail(data).subscribe()
  }
  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
}
